import { useState, useEffect } from 'react';

export function usePageWidth() {
  const getWidth = () =>
    typeof window !== "undefined" ? window.innerWidth : 0;

  // Lazy initializer: runs once during render, safe on the server
  const [width, setWidth] = useState<number>(getWidth);

  useEffect(() => {
    // runs only on client
    let frameId = 0;

    const handleResize = () => {
      cancelAnimationFrame(frameId);
      frameId = requestAnimationFrame(() => {
        setWidth(window.innerWidth);
      });
    };

    // ensure width is correct on mount too
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      cancelAnimationFrame(frameId);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return width;
}